











import Vue from "vue";
import DocumentToolbarAction from "@/components/modules/document/toolbar/DocumentToolbarAction.vue";
import { HyperlinkItem } from "@/types/HyperlinkItem";
import { HyperlinkType, SnackBarTimeout, SourceType } from "@/enums";
import storeHelper from "@/store/store-helper";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
export default Vue.extend({
    name: "MarkAsFavoriteAction",
    components: { DocumentToolbarAction },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        isButton: Boolean,
        enable: { default: true }
    },
    computed: {
        isMarkedAsFavorite(): Boolean {
            return this.documentProperties.marked_as_favorite;
        }
    },
    methods: {
        async addToFavoriteAsync(): Promise<void> {
            let hyperlinkRequest: HyperlinkItem = {
                target: {
                    unc_path: "",
                    email_address: "",
                    web_page_url: "",
                    document_id: this.documentProperties.document_id,
                    type: HyperlinkType.Document
                },
                source: { type: SourceType.Favorite },
                description: this.documentProperties.title
            };
            let hyperlinkId = await storeHelper.hyperlinksStore.createHyperlink(hyperlinkRequest);
            if (!hyperlinkId) {
                await storeHelper.siteStore.setSnackBarMessage(this.$t("general.error").toString());
                return;
            }
            let success = await storeHelper.favoriteItemsStore.createFavorite({
                description: hyperlinkRequest.description,
                hyperlinkId: hyperlinkId
            });

            if (success) {
                await storeHelper.siteStore.setSnackBarMessage(
                    this.$t("document.addedToFavoriteSuccess", {
                        documentName: hyperlinkRequest.description
                    }).toString(),
                    false,
                    SnackBarTimeout.long
                );
                this.$emit("mark-as-favorite");
            } else {
                await storeHelper.siteStore.setSnackBarMessage(this.$t("general.error").toString());
            }
        }
    }
});
